// import React, { Component } from 'react';
// import asyncComponent from './AsyncComponent';
// import {
//     BrowserRouter as Router,
//     Route,
//     Link,
//     Switch,
//     Redirect
// } from 'react-router-dom'
// import { withRouter } from 'react-router'
// import history from './history';
// import { ParallaxProvider } from 'react-scroll-parallax';
//
// import './App.css';
// import 'animate.css/animate.min.css'
//
// //首页
// /*const Home = asyncComponent(() => import('./pages/home'));
// const Nav = asyncComponent(() => import('./components/Nav'));
// const Case = asyncComponent(() => import('./pages/case'));
// const Product = asyncComponent(() => import('./pages/product/index'));
// const Pro = asyncComponent(() => import('./pages/product/pro'));
// const PrDetail = asyncComponent(() => import('./pages/product/proDetail'));
// const News = asyncComponent(() => import('./pages/news/index'));
// const NewsDetail = asyncComponent(() => import('./pages/news/newsDetail'));
// const About = asyncComponent(() => import('./pages/about'));
// const Contact = asyncComponent(() => import('./pages/contact'));
// const Loader = asyncComponent(() => import('./components/loader'));*/
// import Home from './pages/home';
// import Nav from './components/Nav';
// import Case from './pages/case';
// import Product from './pages/product';
// import Pro from './pages/product/pro';
// import PrDetail from './pages/product/proDetail';
// import News from './pages/news';
// import NewsDetail from './pages/news/newsDetail';
// import About from './pages/about';
// import Contact from './pages/contact';
// /*import Loader from './pages/loader';*/
//
// const AnimateComponent = withRouter((  ) => (
//     <div>
//         <Nav/>
//             <Switch>
//                 {/*<Route path="/loader" component={Loader} />*/}
//                 <Route path="/home" component={Home} />
//                 {/*<Route path="/nav" component={Nav} />*/}
//                 <Route path="/case" component={Case} />
//                 <Route path="/product" component={Product} />
//                 <Route path="/pro/:id" component={Pro} />
//                 <Route path="/prDetail/:id" component={PrDetail} />
//                 <Route path="/news" component={News} />
//                 <Route path="/newsDetail/:id" component={NewsDetail} />
//                 <Route path="/about" component={About} />
//                 <Route path="/contact" component={Contact} />
//                 <Redirect to="/home" />
//             </Switch>
//     </div>
// ));
// class App extends Component {
//     render () {
//         return (
//             <Router >
//                 <AnimateComponent/>
//             </Router>
//         )
//     }
// }
// export default App;
import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Link,
    Switch,
    Redirect,
    withRouter
} from 'react-router-dom'
// import { withRouter } from 'react-router'
import history from './history';
import { ParallaxProvider } from 'react-scroll-parallax';

import './App.css';
import 'animate.css/animate.min.css'

//首页
import Home from './pages/home';
import Nav from './components/Nav';
import Case from './pages/case';
import Product from './pages/product';
import Pro from './pages/product/pro';
import PrDetail from './pages/product/proDetail';
import News from './pages/news';
import NewsDetail from './pages/news/newsDetail';
import About from './pages/about';
import Contact from './pages/contact';

const AnimateComponent = withRouter(() => (
    <div>
        <Nav/>
            <div style={{"position": "relative","top": 0,"left": 0}}>
                <Switch>
                    {/*<Route path="/loader" component={Loader} />*/}
                    <Route path="/home" component={Home} />
                    {/*<Route path="/nav" component={Nav} />*/}
                    <Route path="/case" component={Case} />
                    <Route path="/product" component={Product} />
                    <Route path="/pro/:id" component={Pro} />
                    <Route path="/prDetail/:id" component={PrDetail} />
                    <Route path="/news" component={News} />
                    <Route path="/newsDetail/:id" component={NewsDetail} />
                    <Route path="/about" component={About} />
                    <Route path="/contact" component={Contact} />
                    <Redirect to="/home" />
                </Switch>
            </div>
    </div>
));
class App extends Component {
    render () {
        return (
            <Router >
                <AnimateComponent/>
            </Router>
        )
    }
}
export default App;
